import { create } from 'zustand';

const TOKEN_CACHE_KEY = 'machina:mob-token-images';

interface TokenImageState {
  // Token images by mob name
  tokenImages: Record<string, string>;

  // Actions
  loadFromCache: () => void;
  saveToCache: () => void;
  setTokenImage: (name: string, imageUrl: string) => void;
  deleteTokenImage: (name: string) => void;
  clearAllTokens: () => void;
  getMissingTokens: (names: string[]) => string[];
}

export const useTokenImageStore = create<TokenImageState>((set, get) => ({
  tokenImages: {},

  loadFromCache: () => {
    try {
      const cached = localStorage.getItem(TOKEN_CACHE_KEY);
      if (cached) {
        const parsed = JSON.parse(cached);
        console.log('[TokenImageStore] Loaded cached token images:', Object.keys(parsed).length);
        set({ tokenImages: parsed });
      }
    } catch (e) {
      console.warn('[TokenImageStore] Failed to load cached tokens:', e);
    }
  },

  saveToCache: () => {
    const { tokenImages } = get();
    if (Object.keys(tokenImages).length > 0) {
      try {
        localStorage.setItem(TOKEN_CACHE_KEY, JSON.stringify(tokenImages));
        console.log('[TokenImageStore] Saved token cache:', Object.keys(tokenImages).length, 'tokens');
      } catch (e) {
        console.warn('[TokenImageStore] Failed to save token cache:', e);
      }
    }
  },

  setTokenImage: (name: string, imageUrl: string) => {
    set((state) => {
      const newTokenImages = { ...state.tokenImages, [name]: imageUrl };
      // Auto-save to cache
      try {
        localStorage.setItem(TOKEN_CACHE_KEY, JSON.stringify(newTokenImages));
      } catch (e) {
        console.warn('[TokenImageStore] Failed to save token cache:', e);
      }
      return { tokenImages: newTokenImages };
    });
  },

  deleteTokenImage: (name: string) => {
    set((state) => {
      const { [name]: _, ...rest } = state.tokenImages;
      // Auto-save to cache
      try {
        localStorage.setItem(TOKEN_CACHE_KEY, JSON.stringify(rest));
      } catch (e) {
        console.warn('[TokenImageStore] Failed to save token cache:', e);
      }
      return { tokenImages: rest };
    });
  },

  clearAllTokens: () => {
    localStorage.removeItem(TOKEN_CACHE_KEY);
    set({ tokenImages: {} });
  },

  getMissingTokens: (names: string[]) => {
    const { tokenImages } = get();
    return names.filter(name => !tokenImages[name]);
  },
}));
